import { classNames, randomId } from '@pwskills/rachnaui/utils';
import React from 'react';

const LoadingFilterCardSkeleton = ({
  length = 5,
  wrapperClass = '',
}: {
  length?: number;
  wrapperClass?: string;
}) => {
  return (
    <div
      className={classNames(
        'bg-white pb-[15px] gap-4 border-stroke-200 h-[800px] w-full flex flex-col transition-all',
        wrapperClass
      )}
    >
      {Array(length)
        .fill(randomId())
        .map(() => (
          <div key={`i${length + 1}`}>
            <div className="bg-gray-400 rounded p-4 w-full animate-pulse mt-4" />
            <div className="flex flex-col gap-4 mt-2">
              <div className="bg-gray-400 rounded p-2 w-full animate-pulse" />
              <div className="bg-gray-400 rounded p-2 w-full animate-pulse" />
              <div className="bg-gray-400 rounded p-2 w-full animate-pulse" />
            </div>
          </div>
        ))}
    </div>
  );
};

export default LoadingFilterCardSkeleton;
